import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';

import style from '../style.module.scss';
import { setFilterField } from '../actions';

const MediaTypeField = ({ mediaType, setMediaTypeAction }) => (
  <div className={style.customMultiValueInput}>
    <Form.Label className={style.FormLabel}>Media Type</Form.Label>
    <div className={style.RadioInputRow}>
      <Form.Check
        inline
        custom
        type="radio"
        id="All"
        label="All"
        checked={!mediaType}
        onChange={() => setMediaTypeAction(undefined)}
      />
      <Form.Check
        inline
        custom
        type="radio"
        id="Image"
        label="Image"
        checked={mediaType === 'image/jpeg'}
        onChange={() => setMediaTypeAction('image/jpeg')}
      />
    </div>
    <div className={style.RadioInputRow}>
      <Form.Check
        inline
        custom
        type="radio"
        id="Video"
        label="Video"
        checked={mediaType === 'video/mp4'}
        onChange={() => setMediaTypeAction('video/mp4')}
      />
    </div>
  </div>
);

export default connect(
  ({ album: { filterForm: { tempData: { mediaType } } } }) => ({ mediaType }),
  { setMediaTypeAction: setFilterField('mediaType') },
)(MediaTypeField);
